import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "single-form-backoffice"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi-arrow-left" }, null, -1)
const _hoisted_3 = { class: "ms-2 text-lowercase" }
const _hoisted_4 = { class: "p-4" }
const _hoisted_5 = { class: "row align-items-center" }
const _hoisted_6 = { class: "col-sm-2 col-form-label" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_9 = { class: "col-2" }
const _hoisted_10 = { class: "border-top py-4" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi-dash-circle-fill text-danger" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "pb-4 pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitMultiLanguage = _resolveComponent("MrUiKitMultiLanguage")!
  const _component_MrUiKitSelect = _resolveComponent("MrUiKitSelect")!
  const _component_MrUiKitInput = _resolveComponent("MrUiKitInput")!
  const _component_ResultBlockForm = _resolveComponent("ResultBlockForm")!
  const _component_MrUiKitAddField = _resolveComponent("MrUiKitAddField")!
  const _component_MrUiKitMultiUpload = _resolveComponent("MrUiKitMultiUpload")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.hideBack)
          ? (_openBlock(), _createBlock(_component_MrUiKitButton, {
              key: 0,
              onClick: _ctx.onBack,
              classes: ['btn-link', 'text-secondary', 'back-button']
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.t('common.operations.back')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
          }, [
            _createVNode(_component_MrUiKitMultiLanguage, {
              modelValue: _ctx.model.competition,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.competition) = $event)),
              languages: _ctx.languages,
              status: _ctx.v$.competition,
              currentLanguage: _ctx.currentLanguage,
              label: _ctx.t('common.fields.name'),
              name: "competition",
              onTouch: _ctx.onUpdateFormItem,
              placeholder: _ctx.t('common.placeholders.inputCompetition'),
              labelPosition: "left"
            }, null, 8, ["modelValue", "languages", "status", "currentLanguage", "label", "onTouch", "placeholder"]),
            _createVNode(_component_MrUiKitSelect, {
              modelValue: _ctx.model.sport,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.sport) = $event)),
              items: _ctx.sports,
              key: "id",
              status: _ctx.v$.sport,
              labelKey: "name",
              label: "sport",
              labelPosition: "left",
              name: "sport",
              onTouch: _ctx.onUpdateFormItem,
              placeholder: _ctx.t('common.placeholders.sport')
            }, null, 8, ["modelValue", "items", "status", "onTouch", "placeholder"]),
            _createVNode(_component_MrUiKitSelect, {
              modelValue: _ctx.model.discipline,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.discipline) = $event)),
              items: _ctx.disciplines,
              status: _ctx.v$.discipline,
              key: "id",
              labelKey: "name",
              label: "discipline",
              labelPosition: "left",
              name: "disciplines",
              onTouch: _ctx.onUpdateFormItem,
              placeholder: _ctx.t('common.placeholders.discipline')
            }, null, 8, ["modelValue", "items", "status", "onTouch", "placeholder"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.t('result.position')), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_MrUiKitInput, {
                  modelValue: _ctx.model.position,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.position) = $event)),
                  status: _ctx.v$.position,
                  name: "position",
                  onTouch: _ctx.onUpdateFormItem,
                  placeholder: _ctx.t('common.placeholders.position')
                }, null, 8, ["modelValue", "status", "onTouch", "placeholder"])
              ]),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_MrUiKitInput, {
                  modelValue: _ctx.model.totPartecipant,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.totPartecipant) = $event)),
                  placeholder: _ctx.t('common.placeholders.totPartecipant')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ]),
            _createVNode(_component_ResultBlockForm, {
              text: "Me",
              modelValue: _ctx.generalIntermiadiate,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.generalIntermiadiate) = $event)),
              status: _ctx.v$['competitionResultType'],
              onTouch: _ctx.onUpdateFormItem
            }, null, 8, ["modelValue", "status", "onTouch"]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_MrUiKitAddField, {
                modelValue: _ctx.model.intermiadiates,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.intermiadiates) = $event)),
                template: _ctx.intermiadiateTemplate,
                fieldClasses: ['d-flex']
              }, {
                default: _withCtx(({index}) => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_ResultBlockForm, {
                      text: "Me",
                      modelValue: _ctx.model.intermiadiates[index],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.model.intermiadiates[index]) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ])
                ]),
                "button-remove": _withCtx(({click}) => [
                  _createElementVNode("div", {
                    class: "mt-2 ms-2 button-remove",
                    onClick: click
                  }, _hoisted_14, 8, _hoisted_12)
                ]),
                "button-add": _withCtx(({click}) => [
                  _createVNode(_component_MrUiKitButton, {
                    onClick: click,
                    classes: ['btn-sm', 'btn-primary']
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t('common.operations.addIntermiadiate')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 8, ["modelValue", "template"])
            ]),
            _createVNode(_component_MrUiKitMultiUpload, {
              onUpload: _ctx.onUpload,
              modelValue: _ctx.model.attachments,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.attachments) = $event)),
              label: "Attachments"
            }, null, 8, ["onUpload", "modelValue"]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_MrUiKitMultiLanguage, {
                type: "texteditor",
                modelValue: _ctx.model.generalNotes,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.generalNotes) = $event)),
                label: _ctx.t('common.notes'),
                labelPosition: "left",
                languages: _ctx.languages,
                currentLanguage: _ctx.currentLanguage
              }, null, 8, ["modelValue", "label", "languages", "currentLanguage"])
            ]),
            _createVNode(_component_MrUiKitButton, {
              disabled: _ctx.v$.$invalid,
              type: "button",
              onClick: _ctx.onSubmit,
              classes: ['ms-2', 'btn-primary']
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('common.operations.save')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}